export const indexHtmlData = `
<!DOCTYPE html>
<html>

<head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Ibotta</title>

    <meta name="template" content="12_A">

    <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,500,700" rel="stylesheet">

</head>

<body>

<style type="text/css">
{$ css | safe $}
</style>
{% include "content.html" %}
</html>
`


export const contentHtmlData = `
{% set items = [{class:"first"}, {class:"second"}] %}
<section dir="auto">
{% for item in items %}
    <article class="{$ item.class $}">
        <figure>
        </figure>
        <header>
            <div class="wrap">
                <div class="city">
                    {{FeedPreVars["overriding"][Description1] or Offers[{$ loop.index0 $}].Description1 or FeedPreVars["fallback"]["Description1"] or ""}}
                </div>
                <span class="description">
                    {{FeedPreVars["overriding"]["Name"] or Offers[{$ loop.index0 $}].Name or FeedPreVars["fallback"]["Name"] or ""}}
                </span>
                <div class="stars-{{FeedPreVars["overriding"][Description2] or Offers[{$ loop.index0 $}].Description2 or FeedPreVars["fallback"]["Description2"] or ""}} stars"></div>
                <div class="price">
                    {{FeedPreVars["overriding"]["Price"] or Offers[{$ loop.index0 $}].Price or FeedPreVars["fallback"]["Price"] or ""}}
                </div>
                <button>
                    {{Vars["cta"]["text"] or ""}}
                </button>
            </div>
        </header>
    </article>

    <div class="divider">
    </div>

{% endfor %}

    <footer>
        <a href="{{ClickUrl.WithParams TargetUrl:(LogoClickUrl or "")}}">
            <img src="{{FeedPreVars["logo"]["url"] or ""}}">
        </a>
    </footer>
</section>
`

export const customCodeData =`
setup: 

let Offers = [{"ImageUrl": "https://media.staticontent.com/media/pictures/a22d4a24-315e-4983-bb16-461bc6c923c1"}]

let x = "okok"
`